import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { ResetPasswordService } from './reset-password.service';
@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
    detailsObj: any = {};
    linkStatus: String;
    resetPasswordForm: FormGroup;
    constructor(
        private _resetPasswordService: ResetPasswordService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _formBuilder: FormBuilder
    ) { }

    ngOnInit() {
        this.resetPasswordForm = this._formBuilder.group({
            resetPassword: ['', [Validators.required, Validators.minLength(8)]],
            resetConfirmPassword: ['', [Validators.required]],
        });
    }
    resetPassword() {
        if (this.resetPasswordForm.valid && !this.isNotMatching()) {
            this.detailsObj.forgotPasswordKey = this._activatedRoute.snapshot.queryParams.code;
            this.detailsObj.password = this.resetPasswordForm.value.resetPassword;
            this._resetPasswordService.resetPassword(this.detailsObj)
                .subscribe(
                    (result: any) => {
                        this.resetPasswordForm = this._formBuilder.group({
                            resetPassword: ['', [Validators.required, Validators.minLength(8)]],
                            resetConfirmPassword: ['', [Validators.required]],
                        });
                        this._router.navigateByUrl('appLinks');
                    },
                    err => {
                        console.log(err);
                    }
                );
        }
    }
    isNotMatching() {
        // tslint:disable-next-line:max-line-length
        return (this.resetPasswordForm.get('resetPassword').value !== this.resetPasswordForm.get('resetConfirmPassword').value && (!_.isEmpty(this.resetPasswordForm.get('resetConfirmPassword').value)) && this.resetPasswordForm.get('resetConfirmPassword').touched && this.resetPasswordForm.get('resetPassword').valid);
    }
    isFieldValid(field: string) {
        return !this.resetPasswordForm.get(field).valid && this.resetPasswordForm.get(field).touched;
    }
    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field)
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/reset-password/reset-password.component.ts